import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import ActiveLink from "../../layout/active-link/ActiveLink";
import Navbar from "../../layout/header/Header";
import "./SurveyDetails.scss";
import { getSurveyById } from "../../../api/services/survey-apis";
import { getAssessmentById } from "../../../api/services/assessment-apis";
import { getSurveyResponseBySurveyId } from "../../../api/services/survey-apis";
import { toast } from "react-toastify";

const SurveyDetails = () => {
  const [tableData, setTableData] = useState([]);
  const getRowColor = (index: any) => {
    return index % 2 === 1 ? "#D9D9D9" : "white";
  };
  const location = useLocation();
  const data = location.state;
  const navigate = useNavigate();
  const [AssessmentDetails, setAssessmentDetails] = useState(location.state?.AssessmentDetails);
  const [isRefreshing, setIsRefreshing] = useState(false);
  console.log(data, AssessmentDetails);

  useEffect(() => {
    if (["Completed"].includes(AssessmentDetails?.status)) {
      // Fetch survey responses for completed surveys
      getSurveyResponseBySurveyId(AssessmentDetails?.surveyId)
        .then((data: any) => {
          console.log("Survey Response Data:", data.data);
          setTableData(data.data); // Set survey response data
        })
        .catch((error) => {
          toast.error("Failed to fetch survey responses");
          console.error("Error fetching survey responses:", error);
        });
    } else {
      // Fetch assessment data for non-completed surveys
      getAssessmentById(AssessmentDetails?.setName ?? AssessmentDetails?.setId)
        .then((data: any) => {
          console.log("Assessment Data:", data.data);
          setTableData(data.data.sectionList); // Set assessment question list
        })
        .catch((error) => {
          toast.error("Failed to fetch assessment data");
          console.error("Error fetching assessment data:", error);
        });
    }
  }, [AssessmentDetails?.status]);

  const handleRefreshPdf = async () => {
    setIsRefreshing(true);
    try {
      const data = await getSurveyById(AssessmentDetails?.surveyId);
      setAssessmentDetails(data.data);
    } catch (error) {
      toast.error("Failed to refresh PDF status");
    } finally {
      setIsRefreshing(false);
    }
  };

  return (
    <div className="container">
      <Navbar />
      {["Completed"].includes(AssessmentDetails?.status) && (
        <div className="survey-pdf-download">
          {isRefreshing ? (
            <span className="survey-pdf-loading">
              <span className="spinner" />
              Refreshing PDF status...
            </span>
          ) : AssessmentDetails?.pdfUrl ? (
            <a
              href={AssessmentDetails.pdfUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="survey-pdf-btn"
            >
              <span className="pdf-icon" role="img" aria-label="PDF">📄</span>
              View Survey Response PDF
            </a>
          ) : (
            <span className="survey-pdf-message">
              <span className="pdf-icon" role="img" aria-label="PDF">📄</span>
              Survey response PDF is not available yet. Please check again soon.
              <button className="refresh-btn" onClick={handleRefreshPdf}>
                Refresh
              </button>
            </span>
          )}
        </div>
      )}
      <div className="app-pageSize">
        {!data?.flag ? (
          <ActiveLink targetLink="Approval Panel" />
        ) : (
          <div className="link-align">
            <Link to="/dashboard">Dashboard</Link>
            <p style={{ fontSize: "10px" }}>&#10095;</p>
            <p> Survey </p>
          </div>
        )}
        {/* <div> */}
        <div style={{ boxShadow: "0.5px 0.5px 0px 0px grey" }}>
          <div
            className="page-align align-header"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            {data?.flag ? (
              <h4 className="page-align">
                Survey ID : {AssessmentDetails?.surveyId}
              </h4>
            ) : (
              <h4 className="page-align">Survey Details </h4>
            )}
            {AssessmentDetails?.status === "Initiated" && (
              <button className="mail-button-align">Send Reminder</button>
            )}
          </div>
          <div className="details-fields-container">
            <div className="container px-5 py-3">
              <div className="row mb-2">
                <div className="row col-sm-6">
                  <label htmlFor="surveyName" className="label-align col-sm-4">
                    Survey Name:
                  </label>
                  <div className="col-sm-8 content">
                    {AssessmentDetails?.surveyName}
                  </div>
                </div>
                <div className="row col-sm-6">
                  <label htmlFor="surveyName" className="label-align col-sm-4">
                    Status:
                  </label>
                  <div className="col-sm-8 content">
                    {AssessmentDetails?.status}
                  </div>
                </div>
              </div>
              <div className="row mb-2">
                <div className="row col-sm-6">
                  <label htmlFor="description" className="label-align col-sm-4">
                    Initiated By:
                  </label>
                  <div className="col-sm-8 content">
                    {AssessmentDetails?.requestor ?? "LTIM"}
                  </div>
                </div>
                <div className="row col-sm-6">
                  <label htmlFor="domain" className="label-align col-sm-4">
                    Company Name:
                  </label>
                  <div className="col-sm-8 content">
                    {AssessmentDetails?.company}
                  </div>
                </div>
              </div>
              <div className="row mb-2">
                {data?.flag && (
                  <div className="row col-sm-6">
                    <label htmlFor="domain" className="label-align col-sm-4">
                      Created Date:
                    </label>
                    <div className="col-sm-8 content">
                      {AssessmentDetails?.createdDate}
                    </div>
                  </div>
                )}
                {["Initiated"].includes(AssessmentDetails?.status) && (
                  <div className="row col-sm-6">
                    <label htmlFor="domain" className="label-align col-sm-4">
                      Valid Till:
                    </label>
                    <div className="col-sm-8 content">
                      {AssessmentDetails?.validTill &&
                        new Date(AssessmentDetails.validTill)
                          .toISOString()
                          .split("T")[0]}
                    </div>
                  </div>
                )}
                {["Completed"].includes(AssessmentDetails?.status) && (
                  <div className="row col-sm-6">
                    <label htmlFor="domain" className="label-align col-sm-4">
                      Completed On:
                    </label>
                    {AssessmentDetails?.submittedDate}
                  </div>
                )}
                {["Expired"].includes(AssessmentDetails?.status) && (
                  <div className="row col-sm-6">
                    <label htmlFor="email" className="label-align col-sm-4">
                      Email Id:
                    </label>
                    <div className="col-sm-8 content">
                      {AssessmentDetails?.email}
                    </div>
                  </div>
                )}
              </div>
              <div className="row mb-2">
                {!["Expired"].includes(AssessmentDetails?.status) && (
                  <div className="row col-sm-6">
                    <label htmlFor="email" className="label-align col-sm-4">
                      Email Id:
                    </label>
                    <div className="col-sm-8 content">
                      {AssessmentDetails?.email}
                    </div>
                  </div>
                )}
                <div className="row col-sm-6">
                  <label htmlFor="description" className="label-align col-sm-4">
                    Description:
                  </label>
                  <div className="col-sm-8 content">
                    {AssessmentDetails?.surveyDscr}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
        <div style={{ boxShadow: "0px 0.5px 0.5px 0px grey" }}>
          {data?.flag && (

            <div className="details-table-container">
              <table className="details-table">
                <thead>
                  <tr>
                    <th className="table-header-align">S.No</th>
                    <th className="align-heading">Section Name</th>
                    <th className="align-heading">Question</th>
                    {["Completed"].includes(AssessmentDetails?.status) && (
                      <th className="align-heading">Answer</th>
                    )}
                  </tr>
                </thead>
                {!["Completed"].includes(AssessmentDetails?.status) && (
                  <tbody>
                    {(() => {
                      let serialNumber = 1; // Initialize a global counter
                      return tableData.map((section: any) =>
                        section.questionList.map((question: any) => (
                          <React.Fragment key={question.quesId}>
                            <tr>
                              <td>{serialNumber++}</td>
                              <td>{section.sectionName}</td>
                              <td>{question.quesDscr}</td>
                              {["Completed"].includes(
                                AssessmentDetails?.status
                              ) && (
                                  <td>
                                    <select
                                      className="survey-answer"
                                      disabled={true}
                                    >
                                      {question.options.map(
                                        (opt: any, indx: number) => (
                                          <option key={indx} value={opt.optionId}>
                                            {opt.answer}
                                          </option>
                                        )
                                      )}
                                    </select>
                                  </td>
                                )}
                            </tr>
                            {["Completed"].includes(AssessmentDetails?.status) && (
                              <tr className="suggestion-row">
                                <td colSpan={4} align="left">
                                  <strong>Suggestion: </strong>
                                  {question.options.map(
                                    (opt: any, idx: number) => (
                                      <span key={idx}>{opt.suggestion}</span>
                                    )
                                  )}
                                </td>
                              </tr>
                            )}
                          </React.Fragment>
                        ))
                      );
                    })()}
                  </tbody>
                )}
                {["Completed"].includes(AssessmentDetails?.status) && (
                  <tbody>
                    {tableData.map((row: any, index: number) => (
                      <React.Fragment key={index}>
                        <tr>
                          <td>{index + 1}</td> {/* Serial number */}
                          <td>{row.sectionName}</td> {/* Section Name */}
                          <td>
                            {["Completed"].includes(AssessmentDetails?.status)
                              ? row.quesDescr // For completed surveys
                              : row.quesDscr}{" "}
                            {/* For non-completed surveys */}
                          </td>
                          {["Completed"].includes(
                            AssessmentDetails?.status
                          ) && (
                              <td>
                                <select className="survey-answer" disabled={true}>
                                  <option value={row.answer}>{row.answer}</option>{" "}
                                  {/* Answer */}
                                </select>
                                {/* Textarea for additional comment */}
                                {row.additionalComment && (
                                  <textarea
                                    className="additional-comment-textarea"
                                    value={row.additionalComment}
                                    disabled={true} // Make it read-only
                                    rows={Math.min(3, row.additionalComment.split("\n").length)} // Dynamically adjust rows
                                  />
                                )}
                              </td>
                            )}
                        </tr>
                        {["Completed"].includes(AssessmentDetails?.status) && (
                          <tr className="suggestion-row">
                            <td colSpan={4} align="left">
                              <strong>Suggestion: </strong>
                              {row.suggestion} {/* Suggestion */}
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    ))}
                  </tbody>
                )}
              </table>
            </div>

          )}
        </div>

        <div className="submit-wrapper">
          <button
            className="submit-btn-align"
            onClick={() => {
              navigate("/dashboard");
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default SurveyDetails;
